import { defineMessages } from 'react-intl';

export default defineMessages({
    loading: {
        id: 'ml.policychange.location.loading',
        defaultMessage: 'Loading...'
    },
    saving: {
        id: 'ml.policychange.location.saving',
        defaultMessage: 'Saving...'
    },
    locations: {
        id: 'ml.policychange.location.Locations',
        defaultMessage: 'Locations'
    },
    nextBaseDescription: {
        id: 'ml.policychange.location.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.location.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    addALocation: {
        id: 'ml.policychange.location.Add a location',
        defaultMessage: 'Add a location'
    },
    editALocation: {
        id: 'ml.policychange.location.Edit a Location',
        defaultMessage: 'Edit a Location'
    },
    enterLocationDetails: {
        id: 'ml.policychange.location.Enter your location details',
        defaultMessage: 'Enter your location details'
    },
    editLocationDetails: {
        id: 'ml.policychange.location.Edit your location details',
        defaultMessage: 'Edit your location details'
    },
    addLocations: {
        id: 'ml.policychange.location.Add Locations',
        defaultMessage: 'Add Locations'
    },
    editLocations: {
        id: 'ml.policychange.location.Edit Locations',
        defaultMessage: 'Edit Locations'
    },
    underlyingPolicyNotListed: {
        id: 'ml.policychange.location.Policy is not listed',
        defaultMessage: 'Policy is not listed'
    },
    addAPolicy: {
        id: 'ml.policychange.location.Add a Policy',
        defaultMessage: 'Add a Policy'
    },
    cancel: {
        id: 'ml.policychange.location.cancel',
        defaultMessage: 'Cancel'
    },
    addPolicy: {
        id: 'ml.policychange.location.Add policy',
        defaultMessage: 'Add policy'
    },
    requireAnimalLiabilityExclusionIncluded: {
        id: 'ml.policychange.location.We will require an Animal Liability Exclusion to be included on your policy',
        defaultMessage: 'We will require an Animal Liability Exclusion to be included on your policy. Please provide the additional details below:'
    },
    residenceTypeRequiredErrorMessage: {
        id: 'ml.policychange.location.Residence Type Required',
        defaultMessage: 'Residence Type is Required'
    },
    dwellingOccupancyRequiredErrorMessage: {
        id: 'ml.policychange.location.Dwelling Occupancy Type Required',
        defaultMessage: 'Dwelling Occupancy is Required'
    },
    dwellingUsageRequiredErrorMessage: {
        id: 'ml.policychange.location.Dwelling Usage Required',
        defaultMessage: 'Dwelling Usage is Required'
    }

});
